import React, { useState, useEffect } from 'react';
import HeroSection from '../components/hero-section/HeroSection';
import ServiceCards from '../components/service-cards/ServicesCards';
import Banner from '../components/banner/Banner';
import ProjectCards from '../components/project-cards/ProjectCards';
import TurnoverChart from '../components/turnover-chart/TurnoverChart';
import ReviewsSection from '../components/reviews-section/ReviewsSection';
import ContactSection from '../components/contact-section/ContactSection';
import SendMessageSection from '../components/send-message/SendMessageSection';
import '../components/send-message/SendMessageTeaser.css';

function Home() {

  const [desktopMode, setDesktopMode] = useState(false);

  const showReviewSection = () => {
    if (window.innerWidth >= 960) {
      setDesktopMode(true)
    } else {
      setDesktopMode(false)
    }
  };

  useEffect(() => {
    showReviewSection();
    window.addEventListener('resize', showReviewSection)

    return () => {
      window.removeEventListener('resize', showReviewSection)
    }
  }, [])

  return (
    <>
      <HeroSection />
      <ServiceCards />
      <Banner />
      <ProjectCards />
      <TurnoverChart />
      {desktopMode ? <ReviewsSection isHomePage={true} /> : null}
      <SendMessageSection isHomePage={true} />
      <ContactSection isHomePage={true} />
    </>
  );
}

export default Home;
